import { useTemplateContext } from '@vibesites/runtime/react';
import type { HyperlocalQuery } from '@vibesites/schema';

/** The hyperlocal query item backing the current `/featuring/…` page, if any. */
export function useHyperlocalItem(): HyperlocalQuery | undefined {
  return useTemplateContext()?.hyperlocal;
}

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/**
 * Hyperlocal fields arrive either as HTML or as plain text; RichTextContent
 * expects HTML, so plain text is escaped and split into paragraphs on blank
 * lines (single newlines become `<br>`).
 */
export function toRichTextHtml(value: string | null | undefined): string | undefined {
  const text = value?.trim();
  if (!text) return undefined;
  if (/<[a-z][\s\S]*>/i.test(text)) return text;
  return text
    .split(/\n\s*\n/)
    .map((para) => `<p>${escapeHtml(para.trim()).replace(/\n/g, '<br>')}</p>`)
    .join('');
}
